var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.0007 8.33333L11.6673 5M2.08398 17.9167L4.90429 17.6033C5.24887 17.565 5.42115 17.5459 5.58219 17.4937C5.72506 17.4475 5.86102 17.3821 5.98639 17.2995C6.1277 17.2063 6.25027 17.0837 6.49542 16.8386L17.5007 5.83333C18.4211 4.91286 18.4211 3.42047 17.5007 2.5C16.5802 1.57952 15.0878 1.57952 14.1673 2.49999L3.16209 13.5052C2.91694 13.7504 2.79436 13.873 2.70118 14.0143C2.61851 14.1396 2.55316 14.2756 2.50691 14.4185C2.45478 14.5795 2.43564 14.7518 2.39735 15.0964L2.08398 17.9167Z",
    stroke: "current",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEditIcon);
export default __webpack_public_path__ + "static/media/pencil-edit-icon.2d8973f217bf469a488502eb073e4cf2.svg";
export { ForwardRef as ReactComponent };